import React from "react";
import { PieChart, Pie, Cell, ResponsiveContainer, Legend } from "recharts";

const COLORS = ["#6a0dad", "#00a86b", "#ff3c3c", "#007bff", "#ff9900"];
const LABEL_COLORS = COLORS;

const RADIAN = Math.PI / 180;

// Custom label outside the donut chart
const renderCustomizedLabel = ({
  cx,
  cy,
  midAngle,
  innerRadius,
  outerRadius,
  percent,
  index,
}) => {
  const radius = innerRadius + (outerRadius - innerRadius) * 1.2;
  const x = cx + radius * Math.cos(-midAngle * RADIAN);
  const y = cy + radius * Math.sin(-midAngle * RADIAN);

  return (
    <text
      x={x}
      y={y}
      fill={LABEL_COLORS[index]}
      textAnchor={x > cx ? "start" : "end"}
      dominantBaseline="central"
      fontSize={14}
      fontWeight="bold"
    >
      {`${(percent * 100).toFixed(0)}%`}
    </text>
  );
};

const AttendanceDonutChart = ({ data }) => {
  const isEmpty =
    !data || data.length === 0 || data.every((d) => d.value === 0);

  if (isEmpty) {
    return (
      <div
        style={{
          height: "320px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          background: "#fff",
          borderRadius: "15px",
          border: "1px solid #e0e0e0",
          boxShadow: "0 4px 10px rgba(0, 0, 0, 0.06)",
          padding: "20px 30px",
        }}
      >
        <p style={{ fontSize: "16px", color: "#999" }}>No data to display</p>
      </div>
    );
  }

  return (
    <div
      style={{
        height: "320px",
        background: "#fff",
        padding: "20px 30px",
        borderRadius: "15px",
        border: "1px solid #e0e0e0",
        boxShadow: "0 4px 10px rgba(0, 0, 0, 0.06)",
      }}
    >
      <ResponsiveContainer width="100%" height="100%">
        <PieChart>
          <Pie
            data={data}
            cx="50%"
            cy="50%"
            innerRadius={60}
            outerRadius={100}
            paddingAngle={3}
            dataKey="value"
            label={renderCustomizedLabel}
            isAnimationActive={false}
          >
            {data.map((entry, index) => (
              <Cell
                key={`cell-${index}`}
                fill={COLORS[index % COLORS.length]}
                cornerRadius={10}
              />
            ))}
          </Pie>
          <Legend
            iconType="circle"
            layout="vertical"
            verticalAlign="middle"
            align="right"
            formatter={(value, entry, index) => (
              <span
                style={{
                  color: COLORS[index % COLORS.length],
                  fontWeight: 500,
                }}
              >
                {value}
              </span>
            )}
          />
        </PieChart>
      </ResponsiveContainer>
    </div>
  );
};

export default AttendanceDonutChart;
